import fileSaver from 'file-saver'

const writeCsvFile = (csvString, fileName) => {
  fileSaver.saveAs(
    new File([csvString], `${fileName}.csv`, { type: 'text/csv' }),
  )
}

export default writeCsvFile
